var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.485 3.515a12 12 0 1 1-16.971 0 12 12 0 0 1 16.971 0zM4.65 4.65a10.4 10.4 0 1 0 14.7 0 10.4 10.4 0 0 0-14.7 0zm8.154.154a3.2 3.2 0 0 1 3.2 3.2.8.8 0 0 1-1.6 0 1.6 1.6 0 1 0-3.2 0v3.2h2.4a.8.8 0 1 1 0 1.6h-2.4v2.4a2.4 2.4 0 0 1-.137.8H15.2a.8.8 0 1 1 0 1.6H8.8a.8.8 0 0 1 0-1.6.8.8 0 0 0 .8-.8v-2.4h-.8a.8.8 0 0 1 0-1.6h.8V8a3.2 3.2 0 0 1 3.2-3.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSale);
export default __webpack_public_path__ + "static/media/icon-sale.f587e8a3.svg";
export { ForwardRef as ReactComponent };